var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f54d4119-368a-4f7e-a155-30dee88db8f9",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16c91351-c9b5-48ba-990d-b051fef5f7b5",
    "data-name": "Cloud_download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f8458bc-bdbc-4044-a549-eaaddfbfdfdf",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "626fa132-bb53-4a91-94a2-4fb146c6a1b0",
    "data-name": "<Path>",
    d: "M118.35,124s22.44.86,31.19-3a38.27,38.27,0,0,0,22.28-31c1.31-13.09-4.66-27.47-15.94-34.43-5.61-3.45-12.16-4.85-18.71-5.42a78.3,78.3,0,0,0-11.19.5,44.1,44.1,0,0,0-4.26-9.48,43.66,43.66,0,0,0-33.66-21,42.61,42.61,0,0,0-35.72,15.1,44,44,0,0,0-8.91,17.46c-.43,1.7-1.28,6.44-1.28,6.44A33.46,33.46,0,0,0,30.28,65.9C19.77,75.3,17.21,91.36,23.09,104c5.34,11.48,16.81,20,29.57,20h21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 88,
    x2: 96,
    y2: 172,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "122 144 96 172 70 144",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f3b8f72e5174bfc5cece8b41ea9026a5.svg";
export { ForwardRef as ReactComponent };